export default "__VITE_ASSET__Bk7nykCI__"